// import React from 'react';
import {useState, useRef} from 'react';

export default function CaseVideo(props){
    
    // const [fadeClass, setFadeClass] = useState("fadeOut");
    const productRef = useRef();

    useRef(() => {
      productRef.current.addEventListener('animationend', () => {
        if(props.fadeClass == 'fadeIn'){
          props.showCases(false);
        }
      }, {once: true})
    }, [props.fadeClass, props.showCases]);
    
    return(
        <div ref={productRef} className={`relative w-auto ${props.fadeClass}`} style={{'width':props.contentWidth, 'height':props.contentHeight}}>
          <video className={`object-cover w-full h-full rounded-3xl ${props.shadow == true ? "md:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]" : ""}`} autoPlay loop muted>
            <source src={props.src} />
          </video>
        </div>
    )
}